

































































































































































































import Vue from "vue";
import moment from "moment";
import { mapGetters, mapState } from "vuex";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import LicenseModuleFilter from "@/components/TableHeaderFilters/LicenseModuleFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import InstallationResumeDialog from "@/components/InstallationResumeDialog.vue";
import NewSoftwareVersionsFilter from "@/components/TableHeaderFilters/NewSoftwareVersionsFilter.vue";

// Model
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { dataTableItemsPerPage, MODULE_COLORS } from "@/utility/Constants";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { InstallationRemoteLinkStatus } from "@/model/data/remoteLink/InstallationRemoteLinkStatus";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { RootState } from "@/store";

export default Vue.extend({
    components: {
        TableFiltersRow,
        ColumnVisibilityFilter,
        DeviceModelChip,
        InstallationResumeDialog,
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    data() {
        return {
            MODULE_COLORS,
            moment,
            ClientPrivileges,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            firstTime: true,
            LicenseModuleEnum,
            dataTableItemsPerPage,
            BranchFilter,
            DateRangeFilter,
            LicenseModuleFilter,
            ignoreOptionsChanges: false,
            ignoreDataChanges: false,
            confirmationDialog: false,
            options: {},
            selectedItems: [],
            availableHeaders: [],
            showDialog: false,
            selectedInstallation: null,
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                    customAttrs: LicenseModuleEnum.PredictiveMaintenance,
                },
                {
                    headerValue: "agent",
                    filterKey: UpdateTypeEnum.Agent,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Agent },
                },
            ],
        };
    },
    computed: {
        ...mapGetters(["longDateFormat", "isUserSuperAdmin", "authUserHasPrivilege"]),
        initialAvailableHeaders() {
            let initialAvailableHeaders: any = [
                {
                    enabled: true,
                    canBeHidden: false,
                    text: this.$t("remoteLink.sessionStatus"),
                    value: "installationHasActiveSessions",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: false,
                    text: this.$t("common.installationName"),
                    value: "name",
                },
                {
                    enabled: false,
                    canBeHidden: true,
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: true,
                    text: this.$t("common.agent_version"),
                    value: "agent",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("common.agent_ip"),
                    value: "agentInfo.ip",
                },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                },
                {
                    enabled: false,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    sortable: true,
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
            ];
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkHttp)) {
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("remoteLink.openedDate", { protocol: "Web" }),
                    value: "httpSession",
                    sortable: false,
                });
            }
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCaosDb)) {
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("remoteLink.openedDate", { protocol: "Caos DB" }),
                    value: "caosDbSession",
                    sortable: false,
                });
            }
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkSsh)) {
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("remoteLink.openedDate", { protocol: "SSH" }),
                    value: "sshSession",
                    sortable: false,
                });
            }
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkUltraVnc)) {
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("remoteLink.openedDate", { protocol: "UltraVNC" }),
                    value: "ultravncSession",
                    sortable: false,
                });
            }
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCService)) {
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("remoteLink.openedDate", { protocol: "C-Service" }),
                    value: "cserviceSession",
                    sortable: false,
                });
            }
            initialAvailableHeaders.push({
                enabled: true,
                text: this.$t("common.actions"),
                value: "actions",
                sortable: false,
                width: "150px",
            });
            return initialAvailableHeaders;
        },
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
        installations: {
            handler(newValue) {
                if (this.firstTime && this.$route.query.options != null && this.$route.query.options != undefined) {
                    let queryOptions = JSON.parse(atob(this.$route.query.options));
                    this.$emit("options-changed", queryOptions);
                    this.options = queryOptions;
                }
                if (
                    this.firstTime &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != undefined &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != null
                ) {
                    if (this.$route.query.showdialog) this.showDialog = this.$route.query.showdialog == "true";
                    if (this.$route.query.installation) this.selectedInstallation = this.installations.find((i) => i.name == this.$route.query.installation);

                    this.firstTime = false;
                }
            },
            deep: true,
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
        handleClick(value: InstallationRemoteLinkStatus) {
            if (window.getSelection().toString()) {
                return;
            }
            this.showDialog = true;
            this.selectedInstallation = value;
        },
        newTabDialog(value: any) {
            if (this.reqData) {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)), reqData: btoa(JSON.stringify(this.reqData)) },
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)) },
                });
                window.open(routeData.href, "_blank");
            }
        },
    },
});
